<template>
    <div class="cc-delivery-address">
        <div class="cc-delivery-address__header">
            <div class="cc-delivery-address__title" v-if="!pickupInStore">{{ translations['Delivery address'] }}</div>
            <div class="cc-delivery-address__title" v-if="pickupInStore">{{ translations['Contact details'] }}</div>
        </div>
        <div class="cc-delivery-address__main">
            <div class="cc-form-input">
                <label for="deliveryAddress.email" class="cc-label cc-label--text">{{ translations['Email'] }}*</label>
                <input id="deliveryAddress.email" type="email" name="deliveryAddress.email" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.email}" :value="user.deliveryAddress.email" @change="updateEmail">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.email">{{ user.errors.deliveryAddress.email }}</div>
            </div>
            <div class="cc-form-input">
                <input id="user.newsletter" type="checkbox" name="user.newsletter" class="cc-input cc-input--checkbox" :value="user.newsletter" @change="updateNewsletter">
                <label for="user.newsletter" class="cc-label cc-label--checkbox">{{ translations['Register for newsletter'] }}</label>
            </div>
            <div class="cc-form-input">
                <input id="user.optin" type="checkbox" name="user.optin" class="cc-input cc-input--checkbox" :value="user.optin" @change="updateOptin">
                <label for="user.optin" class="cc-label cc-label--checkbox">{{ translations['Register for special events'] }}</label>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.firstname" class="cc-label cc-label--text">{{ translations['Firstname'] }}*</label>
                <input id="deliveryAddress.firstname" type="text" name="deliveryAddress.firstname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.firstname}" :value="user.deliveryAddress.firstname" @change="updateFirstname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.firstname">{{ user.errors.deliveryAddress.firstname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.lastname" class="cc-label cc-label--text">{{ translations['Lastname'] }}*</label>
                <input id="deliveryAddress.lastname" type="text" name="deliveryAddress.lastname" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.lastname}" :value="user.deliveryAddress.lastname" @change="updateLastname">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.lastname">{{ user.errors.deliveryAddress.lastname }}</div>
            </div>
            <div class="cc-form-input">
                <label for="deliveryAddress.phone" class="cc-label cc-label--text">{{ translations['Phone'] }}*</label>
                <input id="deliveryAddress.phone" type="text" name="deliveryAddress.phone" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.phone}" :value="user.deliveryAddress.phone" @change="updatePhone">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.phone">{{ user.errors.deliveryAddress.phone }}</div>
            </div>
            <div v-if="pickupInStore === false">
                <div class="cc-form-input">
                    <label for="deliveryAddress.addressLine1" class="cc-label cc-label--text">{{ translations['Address'] }}*</label>
                    <input id="deliveryAddress.addressLine1" type="text" name="deliveryAddress.addressLine1" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.addressLine1}" :value="user.deliveryAddress.addressLine1" @change="updateAddressLine1">
                    <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.addressLine1">{{ user.errors.deliveryAddress.addressLine1 }}</div>
                </div>
                <div class="cc-form-input">
                    <label for="deliveryAddress.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
                    <input id="deliveryAddress.postalCode" type="text" name="deliveryAddress.postalCode" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.postalCode}" :value="user.deliveryAddress.postalCode" @change="updatePostalCode">
                    <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.postalCode">{{ user.errors.deliveryAddress.postalCode }}</div>
                </div>
                <div class="cc-form-input">
                    <label for="deliveryAddress.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
                    <input id="deliveryAddress.city" type="text" name="deliveryAddress.city" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.city}" :value="user.deliveryAddress.city" @change="updateCity">
                    <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.city">{{ user.errors.deliveryAddress.city }}</div>
                </div>
            </div>
            <div class="cc-form-input">
                <input id="deliveryAddress.showCompanyInformation" type="checkbox" name="deliveryAddress.showCompanyInformation" class="cc-input cc-input--checkbox" :checked="showCompanyInformation" @change="toggleCompanyInformation">
                <label for="deliveryAddress.showCompanyInformation" class="cc-label cc-label--checkbox cc-label--important-checkbox">{{ translations['I want to order products as a company'] }}</label>
            </div>
            <div class="cc-form-input" v-if="showCompanyInformation">
                <label for="deliveryAddress.company" class="cc-label cc-label--text">{{ translations['Company'] }}</label>
                <input id="deliveryAddress.company" type="text" name="deliveryAddress.company" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.company}" :value="user.deliveryAddress.company" @change="updateCompany">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.company">{{ user.errors.deliveryAddress.company }}</div>
            </div>
            <div class="cc-form-input" v-if="showCompanyInformation">
                <label for="deliveryAddress.identificationNumber" class="cc-label cc-label--text">{{ translations['Identification number'] }}</label>
                <input id="deliveryAddress.identificationNumber" type="text" name="deliveryAddress.identificationNumber" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.identificationNumber}" :value="user.deliveryAddress.identificationNumber" @change="updateIdentificationNumber">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.identificationNumber">{{ user.errors.deliveryAddress.identificationNumber }}</div>
            </div>
            <div class="cc-form-input" v-if="showCompanyInformation">
                <label for="deliveryAddress.taxIdentificationNumber" class="cc-label cc-label--text">{{ translations['Tax identification number'] }}</label>
                <input id="deliveryAddress.taxIdentificationNumber" type="text" name="deliveryAddress.taxIdentificationNumber" class="cc-input cc-input--text" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.taxIdentificationNumber}" :value="user.deliveryAddress.taxIdentificationNumber" @change="updateTaxIdentificationNumber">
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.taxIdentificationNumber">{{ user.errors.deliveryAddress.taxIdentificationNumber }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            pickupInStore: function () {
                return this.currentCarrier && this.currentCarrier.pickupInStore
            },
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                showCompanyInformation: state => state.user.showCompanyInformation,
                isUserLoggedIn: state => state.isLoggedIn,
                currentCarrier: state => state.currentCarrier,
            }),
        },
        methods: {
            updateEmail: function (event) {
                this.$store.dispatch('UPDATE_EMAIL', event.target.value);
            },
            updateFirstname: function (event) {
                this.$store.dispatch('UPDATE_FIRSTNAME', event.target.value);
            },
            updateLastname: function (event) {
                this.$store.dispatch('UPDATE_LASTNAME', event.target.value);
            },
            updatePhone: function (event) {
                this.$store.dispatch('UPDATE_PHONE', event.target.value);
            },
            updateAddressLine1: function (event) {
                this.$store.dispatch('UPDATE_ADDRESS_LINE_1', event.target.value);
            },
            updatePostalCode: function (event) {
                this.$store.dispatch('UPDATE_POSTAL_CODE', event.target.value);
            },
            updateCity: function (event) {
                this.$store.dispatch('UPDATE_CITY', event.target.value);
            },
            updateCompany: function (event) {
                this.$store.dispatch('UPDATE_COMPANY', event.target.value);
            },
            updateIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_IDENTIFICATION_NUMBER', event.target.value);
            },
            updateTaxIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_TAX_IDENTIFICATION_NUMBER', event.target.value);
            },
            updateNewsletter: function (event) {
                this.$store.commit('SET_USER_NEWSLETTER', event.target.checked);
            },
            updateOptin: function (event) {
                this.$store.commit('SET_USER_OPTIN', event.target.checked);
            },
            toggleCompanyInformation: function (event) {
                this.$store.commit('SET_USER_SHOW_COMPANY_INFORMATION', event.target.checked);
            },
        },
        name: 'DeliveryAddress',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-delivery-address {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-delivery-address__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-delivery-address__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-delivery-address__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }

        .cc-input {
            &.cc-input--text {
                width: 100%;
            }
        }

        .cc-label {
            &.cc-label--important-checkbox {
                font-size: 16px;
            }
        }
    }
</style>
